// React
import { motion } from "framer-motion";

// Assets
import mastercard from "../../assets/images/pricelist/Mastercard.png";
import maestro from "../../assets/images/pricelist/maestro.png";
import visa from "../../assets/images/pricelist/visa.png";
import visaElectron from "../../assets/images/pricelist/visa_electron.png";
import vpay from "../../assets/images/pricelist/V_Pay_logo.png";
import otp from "../../assets/images/pricelist/otp_szepkartya.png";
import kh from "../../assets/images/pricelist/k&h_szepkartya.png";

/* ordered list of logos to show */
const logos = [
  { src: mastercard, alt: "Mastercard" },
  { src: maestro, alt: "Maestro" },
  { src: visa, alt: "Visa" },
  { src: visaElectron, alt: "Visa Electron" },
  { src: vpay, alt: "V Pay" },
  { src: otp, alt: "OTP SZÉP kártya" },
  { src: kh, alt: "K&H SZÉP kártya" },
];

const fadeUp = i => ({
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { delay: i * .05, duration: .4 } }
});

export default function PaymentMethods(promps) {
  return (
    <section className="payment-bar-wrapper">
      <motion.div
        variants={fadeUp(promps.motionOrder)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-50px" }}
      >
        <div
          className="glass-payment-bar"
          role="group"
          aria-label="Elfogadott fizetési módok"
        >
          {logos.map(({ src, alt }) => (
            <img key={alt} src={src} alt={alt} className="payment-bar-img" />
          ))}
        </div>
      </motion.div>
    </section>
  );
}